import { c as _c } from "react-compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const Calendar = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 1c.5523 0 1 .4477 1 1v1.0016c.4755.0033.891.0131 1.2518.0426.5621.046 1.0788.1445 1.5642.3918a4 4 0 0 1 1.748 1.748c.2473.4854.3459 1.002.3918 1.5642C22 7.2894 22 7.9537 22 8.7587v8.4826c0 .805 0 1.4693-.0442 2.0105-.0459.5621-.1445 1.0788-.3918 1.5642a4 4 0 0 1-1.748 1.748c-.4854.2473-1.0021.3459-1.5642.3918C17.7106 23 17.0463 23 16.2413 23H7.7587c-.805 0-1.4693 0-2.0105-.0442-.5621-.0459-1.0788-.1445-1.5642-.3918a4 4 0 0 1-1.748-1.748c-.2473-.4854-.3459-1.0021-.3918-1.5642C2 18.7106 2 18.0463 2 17.2413V8.7587c0-.805 0-1.4693.0442-2.0105.046-.5621.1445-1.0788.3918-1.5642a4 4 0 0 1 1.748-1.748c.4854-.2473 1.002-.3459 1.5642-.3918.3608-.0295.7763-.0393 1.2518-.0426V2c0-.5523.4477-1 1-1s1 .4477 1 1v1h6V2c0-.5523.4477-1 1-1M7 5.0018V6c0 .5523.4477 1 1 1s1-.4477 1-1V5h6v1c0 .5523.4477 1 1 1s1-.4477 1-1v-.9982c.4455.003.7954.0118 1.089.0358.4384.0358.6626.1007.819.1804.3763.1917.6823.4977.874.874.0797.1564.1446.3806.1804.819C19.9992 7.3611 20 7.9434 20 8.8V9H4v-.2c0-.8566.0008-1.4389.0376-1.889.0358-.4384.1007-.6626.1804-.819a2 2 0 0 1 .874-.874c.1564-.0797.3806-.1446.819-.1804.2936-.024.6435-.0327 1.089-.0358",
      clipRule: "evenodd"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = /*#__PURE__*/_jsx("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      fill: "none",
      viewBox: "0 0 24 24",
      ...props,
      children: t0
    });
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Calendar;
//# sourceMappingURL=Calendar.js.map